import { isNil } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ActionInfo } from '@/store/InsightsStore';
import { emptyValue } from '@/store/LeakageStore';
import { formatThousands } from '@/utils/util-functions';

import ActionCountDetails from './ActionCountDetails';

interface BottomSectionProps {
  actionsTaken: ActionInfo;
  actionsPending: ActionInfo;
  isLoading?: boolean;
}

const BottomSection = ({ actionsTaken, actionsPending, isLoading }: BottomSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex-row">
      <div className="card">
        <span className="card-title">{t('actionsPending')}</span>
        <ActionCountDetails
          actionCount={actionsPending?.count}
          value={`${isNil(actionsPending?.value) ? emptyValue : formatThousands(actionsPending?.value)} ${
            actionsPending?.currency ?? ''
          }`}
          label={t('savingsOpportunity')}
          chipClassName="background-color-red"
          isLoading={isLoading}
        />
      </div>
      <div className="card">
        <span className="card-title">{t('actionsTaken')}</span>
        <ActionCountDetails
          actionCount={actionsTaken?.count}
          value={`${isNil(actionsTaken?.value) ? emptyValue : formatThousands(actionsTaken?.value)} ${
            actionsTaken?.currency ?? ''
          }`}
          label={t('saved')}
          chipClassName="background-color-green"
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default BottomSection;
